import React, { useRef, useEffect, useState } from 'react';
import { Container, CardBody, Card } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { PreviewHTML } from 'vivace-fluent-motion';
import WebapiCommon from '@common/util/webapi.common';
import * as commonActions from '@common/common.action';
import RelatorioReceptaculos from '../../../../../../controleTarefas/Recptaculos/Impressao';
import IntlMessage from "../../../../../../../helpers/intlMessage";

function ImpressaoReceptaculos ({
  laudo,
  modalControleReceptaculo,
  setModalControleReceptaculo
}) {
  const componentRef = useRef();
  const dispatch = useDispatch();
  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const [cassetesCriadosNoPeriodo, setCassetesCriadosNoPeriodo] = useState([]);
  const [previewHTML, setPreviewHTML] = useState(false);

  useEffect(() => {
    if (modalControleReceptaculo) {
      gerarRelatorio(laudo);
    }
  }, [modalControleReceptaculo]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  const gerarRelatorio = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    WebapiCommon.getLaudoBlocosControleReceptaculo('', '', laudoId).then(
      resp => {
        dispatch(commonActions.showFadeCarregando(false));

        if (!resp.data.length) {
          const message = <IntlMessage id = "dashboards.reports.examNoCassete"/>
          dispatch(commonActions.showAlerta('alerta', message, 3000));
          setModalControleReceptaculo && setModalControleReceptaculo(false);
          return;
        }

        const dataFormated = resp.data.map(item => ({
          ...item,
          urgencia: item.urgencia ? 'SIM' : 'NÃO',
          novosCortes: item.novosCortes ? 'SIM' : 'NÃO'
        }));
        setCassetesCriadosNoPeriodo(dataFormated);
        setPreviewHTML(true);
      }
    );
  };

  const ComponentHTML = ({ id }) => {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                <RelatorioReceptaculos lista={cassetesCriadosNoPeriodo} />
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => {
          setPreviewHTML(e);
          setModalControleReceptaculo && setModalControleReceptaculo(e);
        }}
        onPrint={handlePrint}
      />
    </div>
  );
}

export default ImpressaoReceptaculos;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/blocos/ImpressaoReceptaculos/index.js